export default __webpack_public_path__ + "static/media/FECHAS_08.b9d034e7.png";